import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import PageElements from '@mirinae/lessons/components/lesson/PageElements';
import MiniLessonCard, { MiniLessonCardContent } from '@mirinae/lessons/components/lesson/elements/MiniLessonCard';

import { UserAgent } from '@mirinae/js-utils';
import { PageTop } from './DefaultPage';

const isMobile = !UserAgent.os.isOthers;

const MobileMiniLessonCardStackWrapper = styled.div`
    display: flex;
    justify-content: center;
    min-height: auto;
    flex-direction: column;
`;

const MiniLessonCardRowWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    min-height: auto;
    flex-direction: row;
`;
const MiniLessonCardContentWrapper = styled.div`
    & + & {
        margin-left: 20px;
    }
`;

const IrregularMiniLessonNav = ({ page }) => {
    const player = useContext(PlayerContext);

    // save all miniLessonCards in case we will manually render them in a stack on mobile
    const miniLessonCards = player.currentStep.children.filter(e => e.componentName === 'miniLessonCard').sort((c1, c2) => c1.geom.x - c2.geom.x);

    // the buttonLayout element on mobile, render all the cards in a column inside it
    const MobileMiniLessonCardStack = ({ element }) => (
        <MobileMiniLessonCardStackWrapper>
            { miniLessonCards.map(mlc => (
                <MiniLessonCard key={mlc.index} element={mlc} geomElement={element} /> // use the geometry of the placeholder buttonLayout element
            ))}
        </MobileMiniLessonCardStackWrapper>
    );
    
    const MiniLessonCardRow = () => (
        <MiniLessonCardRowWrapper>
            { miniLessonCards.map(mlc => (
                <MiniLessonCardContentWrapper key={mlc.index}>
                    <MiniLessonCardContent element={mlc} />
                </MiniLessonCardContentWrapper>
            ))}
        </MiniLessonCardRowWrapper>
    );
    // don't auto-render cards
    const displayFilter = e => e.componentName !== 'miniLessonCard';
    // if we're on mobile and rendering the 'buttonLayout' placeholder, replace it with a column of the saved cards
    const mapComponent = e => e.name === 'buttonLayout' && (isMobile ? MobileMiniLessonCardStack : MiniLessonCardRow);

    return (
        <>
            <PageTop page={page} />
            <PageElements
                page={page}
                displayFilter={displayFilter}
                mapComponent={mapComponent} />
        </>
    );
};

export default IrregularMiniLessonNav;
